export default "__VITE_ASSET__lgdF4vC___"